<template>
  <div>
    <CRow>
<!--      <CCol col="6">-->
<!--        <CCard class="bg-style2">-->
<!--          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">-->
<!--            <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon" class="mr-2"/> ภาพรวมการพัฒนา (หัวข้อที่บุคลลากรเลือกมาพัฒนามากที่สุด 5 อันดับแรก) </span>-->
<!--          </CCardHeader>-->
<!--          <CCardBody>-->
<!--            <CRow class="mb-3">-->
<!--              <CCol>-->
<!--                <CChartDoughnut-->
<!--                    :datasets="onDataChart3(item)"-->
<!--                    :labels="[ 'No Gap' , 'Gap found' ]"-->
<!--                />-->
<!--              </CCol>-->
<!--            </CRow>-->
<!--          </CCardBody>-->
<!--        </CCard>-->
<!--      </CCol>-->

      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon" class="mr-2"/> ภาพรวมการพัฒนา </span>
            <div class="card-header-actions">
              Total : {{item.length}}
            </div>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol class="mb-sm-4" sm="12" md="6" v-if="item.length > 0">
                <CChartDoughnut
                    :datasets="onDataChart3(item.slice(0,5))"
                    :labels="item.slice(0,5).map(item => item.title+' ('+item.value+')')"
                />
              </CCol>
              <CCol>
                <CDataTable
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    :items="item"
                    :fields="fields"
                    :items-per-page="small ? 50 : 5"
                    :dark="dark"
                    pagination
                    :loading="loading"
                    sorter
                >
                  <template #index="{item,index}">
                    <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                  </template>

                  <template #value="{item,index}">
                    <td class="text-center"> {{ item.value }}</td>
                  </template>

                  <template #isTalent="{ item, index}">
                    <td class="text-center" > {{ (item.isTalent == true)?$t('gap.found'):$t('gap.notFound') }}</td>
                  </template>


                  <template #action="{item,index}">
                    <td style="width: 140px">
                      <CRow>
                        <CCol class="text-center">
                          <!--                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.detail') }" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >-->
                          <!--                    <CIcon name="cil-description"/>-->
                          <!--                  </CButton>-->
                          <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.assessment') }"  size="sm" color="dark" shape="pill" variant="outline" @click="onChangeAssessment(item, index)"  >
                            <CIcon name="cil-people"/>
                          </CButton>

                        </CCol>
                      </CRow>
                    </td>
                  </template>


                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import {value} from "@vue/cli-plugin-e2e-nightwatch/generator/template/tests/e2e/custom-assertions/elementCount";

export default {
  name: 'Method_IDP',
  components: {CChartDoughnut},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item:{
      type: Array,
      default() {
        return []
      }
    },


    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"title", label:"Title"},
          {key:"value", label:"Count",_style: 'width:150px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: Boolean,
  },

  data: function () {
    return {
      isDialog: false,
      collapseDuration: 0,

      nodeData:{
        children:[]
      },

      prepare:{}
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    value,
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

    },
    onDismiss(){
      this.isDialog = false;
    },


    onDataChart3(item){
      return  [{
        backgroundColor: [
          '#EB5B00',
          '#0D92F4',
          '#FF2929',
          '#FFB200',
          '#5CB338',
        ],

        data: item.map(item => item.value),
        value:  item.map(item => item.title)
      }]
    },

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {

    // item(value){
    //   var objsToChart = this.item.slice(0,5);
    //   console.log(objsToChart)
    // }
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
